/* eslint-disable react/require-default-props */
import React from 'react';
import { Formik, FormikHelpers } from 'formik';

import { validationSchema, formInitialValues } from './formikConstants';
import { StudentReviewFormComponent } from './StudentReviewFormComponent';
import { ReviewerOption } from './types/ReviewerOption';
import { UserSchool } from './types/UserSchool';
import { StudentFormValues } from './types/StudentFormValues';
import { ReviewerType } from '../../../enums';

type FormProps = {
  userSchools: UserSchool[];
  reviewTextRef: React.RefObject<HTMLTextAreaElement>;
  setReviewerType(type: ReviewerType): void;
  reviewersOptions: ReviewerOption[];
  onFormSubmit(values, { setErrors, setStatus, setSubmitting }: FormikHelpers<StudentFormValues>): void;
  minCommentLength?: number;
};

const StudentReviewForm = ({
  onFormSubmit, userSchools, reviewTextRef, setReviewerType, reviewersOptions, minCommentLength,
}: FormProps) => (
  <Formik
    initialValues={formInitialValues}
    onSubmit={onFormSubmit}
    validationSchema={validationSchema(minCommentLength || 200)}
  >
    <StudentReviewFormComponent
      userSchools={userSchools}
      reviewTextRef={reviewTextRef}
      setReviewerType={setReviewerType}
      reviewersOptions={reviewersOptions}
      minCommentLength={minCommentLength}
    />
  </Formik>
);

export { StudentReviewForm };
